module.exports = __webpack_public_path__ + "img/studentenwohnheimvallendar_2.94a60f2d.jpg";